/* Madam Muse perf helpers (pass 46).
   Scroll-hover guard: while the page is scrolling, content moves under a still mouse and every product card it passes
   fires pointerenter -> Horizon's card previewImage (a forced-layout slide change, ~100 ms) and the quick-add product
   prefetch (fetch + parse of a whole product page). Measured as the main source of desktop scroll jank. Pointer events
   that only happen because the page scrolled are dropped at the window capture phase, before any theme/app handler.
   `scroll` does not bubble, but a capturing window listener sees it for every scroller (desktop scrolls .page-wrapper). */
(function () {
  var scrolling = false;
  var timer = 0;
  function onScroll() {
    scrolling = true;
    clearTimeout(timer);
    timer = setTimeout(function () { scrolling = false; }, 200);
  }
  /* enter/leave stay paired: when an element's enter was dropped, its next leave is dropped too (whenever it happens),
     otherwise Horizon's resetImage would step a card back from a preview it never showed and land on the wrong photo */
  var dropped = new WeakSet();
  function onEnter(event) {
    if (event.pointerType !== 'mouse') return;
    if (scrolling) { dropped.add(event.target); event.stopImmediatePropagation(); }
    else dropped.delete(event.target);
  }
  function onLeave(event) {
    if (event.pointerType !== 'mouse' || !dropped.has(event.target)) return;
    dropped.delete(event.target);
    event.stopImmediatePropagation();
  }
  window.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('pointerenter', onEnter, true);
  window.addEventListener('pointerleave', onLeave, true);
})();
